export default {
    test: 'https://coreid-test.assently.com/embed/coreid.js',
    production: 'https://coreid.assently.com/embed/coreid.js'
}